import React, { ReactElement } from 'react';
import { View, StyleSheet } from 'react-native';
import { WH, WW } from '_utils';
import { screenMargin, smallestMargin } from '_utils/sizes';
import SkeletonLoader from 'Components/SkeletonLoader';

const GroupsListSkeletonLoader = (): ReactElement => {
    return (
        <View style={styles.container}>
            {/* Skeleton for Tabs */}
            <SkeletonLoader variant="provider" style={styles.tabs}>
                <SkeletonItem index={0} />
                <SkeletonItem index={1} />
                <SkeletonItem index={2} />
                <SkeletonItem index={3} />
                <SkeletonItem index={4} />
            </SkeletonLoader>
        </View>
    );
};

interface SkeletonItemProps {
    index: number;
}

const SkeletonItem = ({ index }: SkeletonItemProps): ReactElement => (
    <SkeletonLoader variant="background" index={index} style={styles.itemContainer}>
        {/* Avatar */}
        <SkeletonLoader variant="foreground" style={styles.avatar} />

        {/* Title and Member Count */}
        <View style={styles.contentWrapper}>
            <SkeletonLoader variant="foreground" style={styles.titleBar} />
            <SkeletonLoader variant="foreground" style={styles.memberCountBar} />
        </View>
    </SkeletonLoader>
);

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    headerBar: {
        height: WH * 0.05,
        width: '100%',
        borderRadius: 4,
        marginBottom: WH * 0.02,
    },
    tabs: {
        flex: 1,
        gap: smallestMargin,
        marginTop: smallestMargin,
    },
    itemContainer: {
        padding: screenMargin,
        paddingTop: screenMargin,
        flexDirection: 'row',
        gap: WW * 0.04,
        alignItems: 'center',
    },
    avatar: {
        width: WW * 0.18,
        height: WW * 0.18,
        borderRadius: (WW * 0.18) / 2,
    },
    contentWrapper: {
        flexDirection: 'column',
        flex: 1,
    },
    titleBar: {
        height: WH * 0.025,
        width: '85%',
        borderRadius: 4,
    },
    memberCountBar: {
        height: WH * 0.02,
        width: '60%',
        borderRadius: 4,
        marginTop: WH * 0.01,
    },
});

export default GroupsListSkeletonLoader;
